import { ClientConfig } from 'src/clients-internal/configuration.model';
import { createAction } from 'typesafe-actions';

export const configurationInit = createAction('CONFIGURATION:INIT')<
    ClientConfig,
    { clientCode: string }
>();
